const SITE_URL = 'https://trangpt.ai'
const SITE_NAME = 'TranGPT'
const DEFAULT_IMAGE = `${SITE_URL}/icon-512.png`

const productDescription = 'TranGPT 是基于 GPT 架构优化的一站式 AI 翻译与 TTS 语音合成平台，支持 180+ 语言互译、文档翻译、实时语音合成和 RESTful API 集成，适用于跨境电商、外贸业务、多语言客服和国际会议场景。'

const baseKeywords = [
  'TranGPT',
  'AI翻译',
  'GPT翻译',
  '多语言翻译',
  'TTS语音合成',
  '文档翻译',
  '翻译API',
  '跨境电商翻译',
  '外贸翻译',
  '多语言客服'
].join(', ')

const commonFeatureList = [
  '180+ 语言互译',
  '基于 GPT 架构的上下文理解',
  '文本转语音 TTS',
  '文档翻译',
  'RESTful API 集成',
  '适配跨境电商、外贸业务、多语言客服和国际会议场景'
]

const routeSeoMap = {
  home: {
    url: `${SITE_URL}/`,
    title: 'TranGPT - 基于 GPT 架构的一站式 AI 翻译与 TTS 解决方案',
    description: productDescription,
    keywords: baseKeywords,
    schema: ['website', 'organization', 'software']
  },
  product: {
    url: `${SITE_URL}/#/product`,
    title: 'TranGPT 产品功能 - 180+ 语言翻译、TTS 语音合成与翻译 API',
    description: '了解 TranGPT 的核心产品能力：基于 GPT 架构优化的 180+ 语言文本互译、上下文理解、翻译 + TTS 一体化、文档翻译、API 集成和安全稳定访问能力。',
    keywords: `${baseKeywords}, TranGPT产品功能, 上下文翻译, 实时翻译, 语音翻译, API集成`,
    schema: ['software', 'productFeatures']
  },
  product2: {
    url: `${SITE_URL}/#/product2`,
    title: 'TranGPT 产品介绍 - AI 翻译、实时沟通与多语言业务工具',
    description: 'TranGPT 提供 AI 翻译、实时沟通、多语言内容处理和智能客服相关能力，帮助跨境业务团队降低语言沟通成本。',
    keywords: `${baseKeywords}, AI客服系统, 实时沟通, 多语言业务工具`,
    schema: ['software']
  },
  productScheme: {
    url: `${SITE_URL}/#/productScheme`,
    title: 'TranGPT 产品方案 - 跨境电商、外贸、多语言客服与会议翻译场景',
    description: 'TranGPT 面向跨境电商卖家、外贸业务员、出海品牌运营、多语言客服团队和国际会议直播等场景，提供 AI 翻译、TTS 和 API 集成解决方案。',
    keywords: `${baseKeywords}, 跨境电商卖家, 外贸业务员, 出海品牌运营, 国际会议翻译, 多语言客服团队`,
    schema: ['software', 'solutionScenarios']
  },
  advantage: {
    url: `${SITE_URL}/#/advantage`,
    title: 'TranGPT 行业优势 - GPT 架构上下文翻译与多语言沟通效率提升',
    description: 'TranGPT 强调 GPT 架构带来的上下文理解能力，在长句、专业术语、多语言客服、跨境电商和外贸沟通场景中提升翻译准确度与协作效率。',
    keywords: `${baseKeywords}, TranGPT优势, GPT上下文翻译, DeepL替代, 长文本翻译, 专业术语翻译`,
    schema: ['software', 'advantageFaq']
  },
  userInstance: {
    url: `${SITE_URL}/#/userInstance`,
    title: 'TranGPT 用户案例 - 跨境业务团队的 AI 翻译与多语言沟通实践',
    description: '查看 TranGPT 在跨境电商、外贸业务、出海品牌和多语言客服团队中的实际使用反馈，了解 AI 翻译与 TTS 如何提升沟通效率。',
    keywords: `${baseKeywords}, TranGPT用户案例, 跨境电商案例, 外贸翻译案例, 多语言客服案例`,
    schema: ['software']
  },
  tutorial: {
    url: `${SITE_URL}/#/tutorial`,
    title: 'TranGPT 下载与教程 - 快速上手 AI 翻译、TTS 和多语言沟通',
    description: 'TranGPT 下载与使用教程，帮助用户快速上手 AI 翻译、文本转语音、多语言沟通和跨境业务协作功能。',
    keywords: `${baseKeywords}, TranGPT教程, TranGPT下载, AI翻译教程, TTS教程`,
    schema: ['software']
  },
  about: {
    url: `${SITE_URL}/#/about`,
    title: '关于 TranGPT - 官方品牌信息与 AI 翻译平台介绍',
    description: 'TranGPT 是面向跨境电商、外贸业务、国际金融和全球业务团队的多语言翻译与文本转语音 SaaS 平台，提供准确、快速、适应多文化场景的沟通解决方案。',
    keywords: `${baseKeywords}, 关于TranGPT, TranGPT官网, TranGPT官方信息, AI翻译平台`,
    schema: ['organization', 'aboutPage']
  },
  login: {
    title: '登录 TranGPT',
    description: '登录 TranGPT 账号，继续使用 AI 翻译、TTS 语音合成和多语言沟通工具。',
    robots: 'noindex, nofollow'
  },
  register: {
    title: '注册 TranGPT',
    description: '注册 TranGPT 账号，体验 AI 翻译、TTS 语音合成和多语言沟通工具。',
    robots: 'noindex, nofollow'
  },
  resetPassword: {
    title: '重置 TranGPT 密码',
    description: '重置 TranGPT 账号密码。',
    robots: 'noindex, nofollow'
  },
  terms: {
    url: `${SITE_URL}/#/terms`,
    title: 'TranGPT 服务协议',
    description: 'TranGPT 服务协议，了解使用 TranGPT AI 翻译与 TTS 服务的权利、义务及注意事项。'
  },
  privacy: {
    url: `${SITE_URL}/#/privacy`,
    title: 'TranGPT 隐私政策',
    description: 'TranGPT 隐私政策，了解我们如何收集、使用、存储和保护您的个人信息。'
  },
  account: {
    title: 'TranGPT 账号中心',
    description: 'TranGPT 账号中心。',
    robots: 'noindex, nofollow'
  },
  pay: {
    title: 'TranGPT 充值中心',
    description: 'TranGPT 充值中心。',
    robots: 'noindex, nofollow'
  }
}

function organizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: DEFAULT_IMAGE,
    sameAs: ['https://t.me/TranGPT666']
  }
}

function websiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: productDescription,
    inLanguage: ['zh-CN', 'en']
  }
}

function softwareSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: SITE_NAME,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    url: SITE_URL,
    image: DEFAULT_IMAGE,
    description: productDescription,
    featureList: commonFeatureList,
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL
    }
  }
}

function productFeaturesSchema() {
  const features = [
    ['GPT 架构翻译更准确', '基于 GPT 架构深度优化，提升上下文理解、长句翻译和专业术语翻译的稳定性。'],
    ['180+ 全语种覆盖', '覆盖全球主流语言和小语种，适合跨境业务、多语言客服和国际沟通场景。'],
    ['翻译 + TTS 一体化', '将翻译结果转换为自然语音，适用于客服、直播、教育和内容出海场景。'],
    ['API 集成与业务接入', '为开发者和业务系统提供翻译能力接入，支持自动化多语言工作流。']
  ]

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'TranGPT 核心产品功能',
    itemListElement: features.map(([name, description], index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Thing',
        name,
        description
      }
    }))
  }
}

function solutionScenariosSchema() {
  const scenarios = ['跨境电商卖家', '外贸业务员', '出海品牌运营', '开发者技术集成', '多语言客服团队', '国际会议直播']

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'TranGPT 适用业务场景',
    itemListElement: scenarios.map((name, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Audience',
        name
      }
    }))
  }
}

function advantageFaqSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'TranGPT 的核心优势是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'TranGPT 基于 GPT 架构优化，重点提升上下文理解、长句翻译、专业术语处理、多语言沟通和 TTS 语音合成的一体化效率。'
        }
      },
      {
        '@type': 'Question',
        name: 'TranGPT 适合哪些业务场景？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'TranGPT 适合跨境电商、外贸业务、出海品牌运营、多语言客服、国际会议直播和开发者 API 集成等场景。'
        }
      }
    ]
  }
}

function aboutPageSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于 TranGPT',
    url: `${SITE_URL}/#/about`,
    description: routeSeoMap.about.description,
    publisher: organizationSchema()
  }
}

const schemaFactories = {
  organization: organizationSchema,
  website: websiteSchema,
  software: softwareSchema,
  productFeatures: productFeaturesSchema,
  solutionScenarios: solutionScenariosSchema,
  advantageFaq: advantageFaqSchema,
  aboutPage: aboutPageSchema
}

function getRouteSeo(to) {
  return routeSeoMap[to.name] || routeSeoMap.home
}

function getRouteUrl(to, seo) {
  if (seo.url) return seo.url
  if (!to || !to.path || to.path === '/home' || to.path === '/') return `${SITE_URL}/`
  return `${SITE_URL}/#${to.path}`
}

function setMeta(selector, attrs) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    Object.keys(attrs).forEach((key) => {
      if (key !== 'content') element.setAttribute(key, attrs[key])
    })
    document.head.appendChild(element)
  }
  element.setAttribute('content', attrs.content || '')
}

function setNamedMeta(name, content) {
  setMeta(`meta[name="${name}"]`, { name, content })
}

function setPropertyMeta(property, content) {
  setMeta(`meta[property="${property}"]`, { property, content })
}

function setLink(selector, attrs) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('link')
    document.head.appendChild(element)
  }
  Object.keys(attrs).forEach((key) => element.setAttribute(key, attrs[key]))
}

function updateJsonLd(schemaKeys) {
  document.head.querySelectorAll('script[data-seo-json-ld="true"]').forEach((node) => node.remove())

  ;(schemaKeys || []).forEach((key) => {
    const factory = schemaFactories[key]
    if (!factory) return
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.setAttribute('data-seo-json-ld', 'true')
    script.textContent = JSON.stringify(factory())
    document.head.appendChild(script)
  })
}

export function updateSeo(to) {
  if (typeof document === 'undefined') return

  const seo = getRouteSeo(to)
  const url = getRouteUrl(to, seo)
  const title = seo.title || routeSeoMap.home.title
  const description = seo.description || routeSeoMap.home.description
  const keywords = seo.keywords || baseKeywords
  const robots = seo.robots || 'index, follow'
  const image = seo.image || DEFAULT_IMAGE

  document.documentElement.setAttribute('lang', 'zh-CN')
  document.title = title

  setNamedMeta('description', description)
  setNamedMeta('keywords', keywords)
  setNamedMeta('robots', robots)
  setNamedMeta('referrer', 'strict-origin-when-cross-origin')
  setNamedMeta('ai-robots', robots)
  setNamedMeta('ai-brand-name', SITE_NAME)
  setNamedMeta('ai-official-domain', SITE_URL)
  setNamedMeta('ai-product-category', 'AI translation SaaS, text-to-speech, translation API')

  setPropertyMeta('og:site_name', SITE_NAME)
  setPropertyMeta('og:type', 'website')
  setPropertyMeta('og:locale', 'zh_CN')
  setPropertyMeta('og:locale:alternate', 'en_US')
  setPropertyMeta('og:title', title)
  setPropertyMeta('og:description', description)
  setPropertyMeta('og:url', url)
  setPropertyMeta('og:image', image)

  setNamedMeta('twitter:card', 'summary_large_image')
  setNamedMeta('twitter:title', title)
  setNamedMeta('twitter:description', description)
  setNamedMeta('twitter:image', image)

  setLink('link[rel="canonical"]', { rel: 'canonical', href: url })
  setLink('link[rel="alternate"][hreflang="zh-CN"]', { rel: 'alternate', hreflang: 'zh-CN', href: `${SITE_URL}/` })
  setLink('link[rel="alternate"][hreflang="en"]', { rel: 'alternate', hreflang: 'en', href: `${SITE_URL}/?lang=en` })

  updateJsonLd(seo.schema)
}

export default updateSeo
